import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, Form } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { environment } from 'src/environments/environment';
import { StateService } from 'src/app/services/states.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CustomerService } from 'src/app/services/customer.service';
import { empty } from 'rxjs';
import { isString } from 'util';
import { MatDialog } from '@angular/material';
import { DialogHTML } from '../dialogs-html/dialog-html.component';
import { MessValidemail } from '../dialogs-messages/mess_validemail_dialog.component';
import { MessChangeMDP } from '../dialogs-messages/mess_changemdp_dialog.component';
import { deleteAccountService } from '../../services/Customer/deleteAccount.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
    essai_gratuit: boolean = false;
    source: string = "";
    campagne: string = "";

    user: any = "";
    signupForm: FormGroup = new FormGroup({});
    credits: any = [];
    errormail: boolean = false;
    messagemail: string = "";
    uppercase = 0;
    integer = 0;
    special = 0;
    lengthpass = 0;
    addressForm: FormGroup = new FormGroup({});
    optionsVille: any = false;
    errormdp: boolean;
    messageError: any;
    logoImgLink;

    civilites = [
        { label: "Madame", value: "madame", selected: false },
        { label: "Monsieur", value: "monsieur", selected: false },
        { label: "Maître", value: "maitre", selected: false },
    ];

    constructor(
        private stateService: StateService,
        private router: Router,
        private formBuilder: FormBuilder,
        private appService: AppService,
        private customerService: CustomerService,
        private cookies: CookieService,
        private cdf: ChangeDetectorRef,
        private deleteAccountService: deleteAccountService,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
    ) {
        this.source = 'source' in this.activatedRoute.snapshot.queryParams ? this.activatedRoute.snapshot.queryParams.source : "";
        this.campagne = 'campagne' in this.activatedRoute.snapshot.queryParams ? this.activatedRoute.snapshot.queryParams.campagne : "";
    }

    ngOnInit() {

        if (this.router.url.indexOf('/essai_gratuit') > -1) {
            this.essai_gratuit = true;
        } else {
            this.essai_gratuit = false;
        }

        if (this.essai_gratuit) {
            this.signupForm = this.formBuilder.group({
                civilite: new FormControl("", [Validators.required]),
                entreprise: new FormControl("", [Validators.required]),
                firstname: new FormControl(""),
                name: new FormControl("", [Validators.required]),
                email: new FormControl("", [
                    Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
                    Validators.required
                ]),
                password: new FormControl("", [Validators.required]),
                confpassword: new FormControl("", [Validators.required]),
            });
            this.addressForm = this.formBuilder.group({
                telephone: new FormControl("", [Validators.required]),
            });
        } else {
            this.stateService.user.subscribe((user) => {
                this.user = user;
                if (!user) {
                    window['tryga']('send', 'event', 'connexion', 'se_creer_un_compte', '', '');
                    this.signupForm = this.formBuilder.group({
                        civilite: new FormControl("", [Validators.required]),
                        entreprise: new FormControl("", [Validators.required]),
                        firstname: new FormControl(""),
                        name: new FormControl("", [Validators.required]),
                        email: new FormControl("", [
                            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
                            Validators.required
                        ]),
                        password: new FormControl("", [Validators.required]),
                        confpassword: new FormControl("", [Validators.required]),
                    });
                    this.addressForm = this.formBuilder.group({
                        emailadresse: new FormControl("", [
                            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")
                        ]),
                        telephone: new FormControl("", [Validators.required]),
                        rue: new FormControl("", [Validators.required]),
                        ruecomp: new FormControl(""),
                        ville: new FormControl("", [Validators.required]),
                        codepost: new FormControl("", [Validators.required]),
                        pays: new FormControl("France", [Validators.required])
                    });
                }
                else {
                    console.log(this.user);
                    if (this.user.logo) {
                        this.logoImgLink = window.location.origin + "/upload/logos/" + this.user.ID + "/" + this.user.logo;
                    }

                    if (this.user.etat === 3) {// client Odoo compte créé par défaut, il faut qu'il renseigne obligatoirement le mdp
                        this.signupForm = this.formBuilder.group({
                            entreprise: new FormControl(user.firm, [Validators.required]),
                            civilite: new FormControl(user.civilite, [Validators.required]),
                            firstname: new FormControl(user.firstname),
                            name: new FormControl(user.name, [Validators.required]),
                            email: new FormControl(user.email, [
                                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
                                Validators.required
                            ]),
                            password: new FormControl("", [Validators.required]),
                            confpassword: new FormControl("", [Validators.required]),
                        });
                    } else {
                        this.signupForm = this.formBuilder.group({
                            entreprise: new FormControl(user.firm, [Validators.required]),
                            civilite: new FormControl(user.civilite, [Validators.required]),
                            firstname: new FormControl(user.firstname),
                            name: new FormControl(user.name, [Validators.required]),
                            email: new FormControl(user.email, [
                                Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
                                Validators.required
                            ]),
                            password: new FormControl(""),
                            confpassword: new FormControl(""),
                        });
                    }

                    this.civilites.map((title) => {
                        if (user.civilite === title.value) {
                            title.selected = true;
                        }
                    })

                    this.addressForm = this.formBuilder.group({
                        emailadresse: new FormControl(this.user.adresse.emailadresse ? this.user.adresse.emailadresse : this.user.email, [
                            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
                        ]),
                        telephone: new FormControl(this.user.adresse.telephone, [Validators.required]),
                        rue: new FormControl(this.user.adresse.rue, [Validators.required]),
                        ruecomp: new FormControl(this.user.adresse.ruecomp),
                        ville: new FormControl(this.user.adresse.ville, [Validators.required]),
                        codepost: new FormControl(this.user.adresse.codepost, [Validators.required]),
                        pays: new FormControl(this.user.adresse.pays ? this.user.adresse.pays : "France", [Validators.required])
                    });

                    this.customerService.getCredits().subscribe(res => {
                        if (res.result)
                            this.credits = res.result;
                    });
                    if (this.user.adresse && this.user.adresse.codepost && this.user.adresse.codepost.length === 5 && !this.user.adresse.ville) {
                        this.autoVille(this.user.adresse.codepost);
                    }
                }
            })
        }
    }

    ngOnChanges() {
        if (this.router.url.indexOf('/essai_gratuit') > -1) {
            this.essai_gratuit = true;
        } else {
            this.essai_gratuit = false;
        }
    }

    submitRegister() {
        this.errormail = false
        this.errormdp = false
        if (this.signupForm.valid && this.addressForm.valid) {
            if (this.signupForm.get('email').invalid || this.signupForm.get('password').value != this.signupForm.get('confpassword').value) {
                if ((!this.user && this.signupForm.get('password').value != this.signupForm.get('confpassword').value) ||
                    (this.user && this.signupForm.get('password').value != this.signupForm.get('confpassword').value && this.signupForm.get('confpassword').value.length > 0)
                ) {
                    this.errormdp = true;
                }
            } else {
                this.appService.getConnectToken().subscribe((res) => {
                    environment.tokencsrf = res.result.token;
                    if (!this.user)
                        this.signUp();
                    else
                        this.updateUser();
                })
            }
        } else {
            this.validateAllFormFields(this.signupForm);
            this.validateAllFormFields(this.addressForm);
        }
    }

    submitRegisterEssaiGratuit() {
        this.errormail = false
        this.errormdp = false
        if (this.signupForm.valid && this.addressForm.valid) {
            if (this.signupForm.get('email').invalid || this.signupForm.get('password').value != this.signupForm.get('confpassword').value) {
                if ((!this.user && this.signupForm.get('password').value != this.signupForm.get('confpassword').value) ||
                    (this.user && this.signupForm.get('password').value != this.signupForm.get('confpassword').value && this.signupForm.get('confpassword').value.length > 0)
                ) {
                    this.errormdp = true;
                }
            } else {
                this.appService.getConnectToken().subscribe((res) => {
                    environment.tokencsrf = res.result.token;
                    let res1 = this.signupForm.getRawValue();
                    let res2 = this.addressForm.getRawValue();

                    this.appService.registerEssaiGratuit(res1.entreprise, res1.civilite, res1.firstname, res1.name, res1.email, res1.password, res2.telephone, this.source, this.campagne).subscribe((response_essai_gratuit) => {
                        response_essai_gratuit.result.user.credits = response_essai_gratuit.result.credits;
                        response_essai_gratuit.result.user.identity.ID = response_essai_gratuit.result.user.ID;
                        response_essai_gratuit.result.user.identity.email = response_essai_gratuit.result.user.connection.email;

                        if (response_essai_gratuit.result.need_confirm_email) {
                            this.appService.confirmEmail(response_essai_gratuit.result.user.identity.email, response_essai_gratuit.result.token).subscribe((response) => {
                                this.afterSubmitRegisterEssaiGratuit();
                            });
                        } else {
                            this.afterSubmitRegisterEssaiGratuit();
                        }
                    });
                })
            }
        } else {
            this.validateAllFormFields(this.signupForm);
            this.validateAllFormFields(this.addressForm);
        }
    }

    afterSubmitRegisterEssaiGratuit() {
        const dialogRef = this.dialog.open(DialogHTML, {
            data: `<div class="text-center">
                <h4 class="fw-bold color-violet">Votre compte a été créé.</h4>
                <br/>
                <p>Afin de vérifier votre adresse e-mail, <b>un message de confirmation vous a été envoyé.</b></p>
                <br/>
                <p>Une fois cette confirmation effectuée, un dossier sera mis gracieusement à votre disposition afin de vous permettre de tester pleinement les fonctionnalités de <b>Rupture by Cobham</b>.</p>
                <br/>
                <p>Pour toute question ou demande d'accompagnement, notre équipe reste à votre disposition à l'adresse suivante : <a href="mailto:support@cobham-solutions.com">support@cobham-solutions.com</a></p>
            </div>`
        });
        
        dialogRef.afterClosed().subscribe(result => {
            this.router.navigateByUrl("/homepage");
        });
    }

    signUp() {

        let res = this.signupForm.getRawValue();
        let res2 = this.addressForm.getRawValue();

        this.appService.verificationMail(res.email).subscribe((resValid) => {
            if (resValid.result.connect == "KO") {
                this.errormail = true;
                this.messagemail = resValid.result.message;

            }
            else if (resValid.result.connect == "OK") {
                this.appService.register(res.entreprise, res.civilite, res.firstname, res.name, res.email, res.password, res2.telephone).subscribe((resRegister) => {
                    //console.log(resRegister)
                    //TODO message error si creation odoo non fonctionnel

                    resRegister.result.user.credits = resRegister.result.credits;
                    resRegister.result.user.identity.ID = resRegister.result.user.ID;
                    resRegister.result.user.identity.email = resRegister.result.user.connection.email;
                    // this.stateService.updateUser(resRegister.result.user.identity);
                    // environment.tokenauth = resRegister.result.token;
                    // environment.tokencsrf = "";
                    // this.cookies.set("Tokenauth", resRegister.result.token);
                    this.updateAddress(res, res2, resRegister.result.user.ID);
                    let mess = "";
                    this.appService.confirmEmail(resRegister.result.user.identity.email, resRegister.result.token).subscribe((response) => {
                        // console.log(response);
                        if (response.success == false) {
                            mess = response.message;
                        }
                        // this.router.navigateByUrl("/dossier");
                        const dialogRef = this.dialog.open(MessValidemail, {
                            width: '100%',
                            panelClass: 'message-dialog',
                            data: {
                                "email": resRegister.result.user.identity.email,
                                "message": mess
                            }
                        });
                        dialogRef.afterClosed().subscribe(result => {
                            this.router.navigateByUrl("/homepage");
                        });
                    });
                });
            }
        });
    }

    checkPassword(event) {
        this.lengthpass = event.target.value.length;

        let regexInteger: RegExp = /[0-9]/;
        let regexUppercase: RegExp = /[A-Z]/;
        let regexSpecial: RegExp = /[^ \w]/;
        regexSpecial.test(event.target.value) ? this.special = 1 : this.special = 0;
        regexUppercase.test(event.target.value) ? this.uppercase = 1 : this.uppercase = 0;
        regexInteger.test(event.target.value) ? this.integer = 1 : this.integer = 0;
        this.cdf.detectChanges();
    }

    updateUser() {

        let res = this.signupForm.getRawValue();
        this.appService.updateUser(this.user.ID, res.entreprise, res.civilite, res.firstname, res.name, res.email, res.password, { 'type': this.user.type ? 1 : 0 }).subscribe((resRegister) => {
            console.log(resRegister);
            if (resRegister.result.error) {
                this.messageError = "La modification de vos données sur le service Odoo n'a pas fonctionné."
            } else {
                this.messageError = ""
                environment.tokencsrf = "";
                this.updateAddress(res);
                resRegister.result.user.credits = resRegister.result.credits;
                resRegister.result.user.identity.ID = resRegister.result.user.ID;
                resRegister.result.user.identity.email = resRegister.result.user.connection.email;
                this.stateService.updateUser(resRegister.result.user.identity);
                this.router.navigateByUrl("/dossier");
            }
        });
    }

    updateAddress(res = null, res2 = null, id = null) {
        if (res2 === null) { res2 = this.addressForm.getRawValue(); }
        if (res === null) { res = this.signupForm.getRawValue(); }

        let adresse = {
            "nomadresse": res.name,
            'emailadresse': res.email,
            'telephone': res2.telephone,
            'rue': res2.rue,
            'ruecomp': res2.ruecomp,
            'ville': res2.ville,
            'codepost': res2.codepost,
            'pays': res2.pays
        };

        if (id === null) { id = this.user.ID; }
        this.appService.saveAdresse(id, adresse).subscribe((resRegister) => {
            if (resRegister.result.error) {
                this.messageError = "La modification de vos données sur le service Odoo n'a pas fonctionné."
            }
            resRegister.result.user.identity.ID = resRegister.result.user.ID;
            if (this.user.ID) {
                this.stateService.updateUser(resRegister.result.user.identity);
            }
        });
    }

    checkInsert() {
        //let form = this.signupForm.getRawValue();
        // if (form.password != form.confpassword) {
        //   return true
        // }
        return this.signupForm.invalid || this.addressForm.invalid;
    }

    goCredit() {
        this.router.navigateByUrl("/tarifs");
    }

    orderHistory() {
        this.router.navigateByUrl("/history");
    }

    autoVille(event: any) {
        this.optionsVille = "";
        let value = ""
        if (isString(event)) {
            value = event;
        } else {
            value = event.target.value;
        }
        if (value.length === 5) {
            this.customerService.autoVille(value).subscribe((res) => {
                if (res.result && res.result.ville) {
                    this.addressForm.get("ville").setValue(res.result.ville[0]["libelleacheminement"]);
                    this.optionsVille = res.result.ville;
                }
            })
        }
    }

    changePassword() {
        const dialogRef = this.dialog.open(MessChangeMDP, {
            height: '500px',
            width: '800px',
        });
        // dialogRef.afterClosed().subscribe(result => {
        // });
    }

    openDeleteDialog() {
        this.deleteAccountService.openDeleteDialog();
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    isInputInvalid(form: FormGroup, field: string) {
        return !form.get(field).valid && form.get(field).touched;
    }

    uploadLogoClient($file) {
        this.customerService.uploadLogoClient($file[0], this.user.ID).subscribe((res) => {
            if (res.success) {
                this.user.logo = res.file;
                this.logoImgLink = window.location.origin + "/upload/logos/" + this.user.ID + "/" + res.file;
            }
        })
    }
}
